var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 12.5835L9.70218 16.6011C9.8115 16.6557 9.86616 16.6831 9.92349 16.6938C9.97427 16.7033 10.0264 16.7033 10.0772 16.6938C10.1345 16.6831 10.1891 16.6557 10.2985 16.6011L18.3337 12.5835M1.66699 8.4168L9.70218 4.39921C9.8115 4.34455 9.86616 4.31722 9.92349 4.30646C9.97427 4.29693 10.0264 4.29693 10.0772 4.30646C10.1345 4.31722 10.1891 4.34455 10.2985 4.39921L18.3337 8.4168L10.2985 12.4344C10.1891 12.4891 10.1345 12.5164 10.0772 12.5271C10.0264 12.5367 9.97427 12.5367 9.92349 12.5271C9.86616 12.5164 9.8115 12.4891 9.70218 12.4344L1.66699 8.4168Z",
    stroke: "#084F4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorIcon);
export default __webpack_public_path__ + "static/media/creator-icon.b14f96afb1e8f41b7ab506aa2fa60c4b.svg";
export { ForwardRef as ReactComponent };